const lightBlue = {
  main: "#4fa1dc",
  light: "#bdd6ea",
  dark: "#4fa1dc",
};

export { lightBlue };
